/**
 * Preset unit vocabulary for the create form's ingredient unit select. UI-only:
 * the API stores any trimmed string (the select's custom… option swaps in a
 * free-text field), and the empty unit — a bare count like "2 apples" — is
 * offered as "units". Spellings match the seeded cookbook (plural "cups"/
 * "cloves") so new recipes format exactly like existing rows, including the
 * modal's fraction-vs-decimal quantity formatting.
 */
export interface RecipeUnitGroup {
  label: string;
  units: readonly string[];
}

export const RECIPE_UNIT_GROUPS: readonly RecipeUnitGroup[] = [
  { label: 'Weight', units: ['g', 'kg', 'oz', 'lb'] },
  { label: 'Volume', units: ['ml', 'l', 'tsp', 'tbsp', 'cups', 'fl oz'] },
  { label: 'Count', units: ['cloves', 'can', 'pinch'] },
];
